/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Heading,
  Button,
  Table
} from '../'

export const AddressesDisplay = ({ title, rows, editMode, addMode, saveDisabled, saveAdd, noHeader, simple, noActionColumn, goReadOnly, goAdd, className }) => (
  <div className={`slds-m-bottom_xx-large ${className ? className : ''}`}>
    <div className='slds-clearfix'>
      <div className='slds-float_left'>
        <Heading size='medium'>{title}</Heading>
      </div>
      <div className='slds-float_right'>
        {editMode && rows.length > 0
          ? <span>
              <Button onClick={goReadOnly}>Cancel</Button>
            </span>
          : addMode && simple
            ? <span>
                <Button onClick={goReadOnly}>Cancel</Button>
                <Button
                  type='brand'
                  disabled={saveDisabled}
                  onClick={saveAdd}>
                  Save
                </Button>
              </span>
            : <span>
                <Button onClick={goAdd}>Add</Button>
              </span>
        }
      </div>
    </div>
    {rows.length > 0
      ? noHeader
        ? <div>
            <Table
              rows={rows}
            />
          </div>
        : <div>
            <Table
              columns={simple
                ? noActionColumn
                  ? ['Value', 'Default']
                  : ['Value', 'Default', '']
                : ['Type', 'Value', 'Default', 'Inactive', 'Opted-out', '']
              }
              rows={rows}
            />
          </div>
      : <span>No contact details currently specified</span>
    }
  </div>
)

AddressesDisplay.propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  addMode: PropTypes.bool,
  editMode: PropTypes.bool,
  saveDisabled: PropTypes.bool,
  noHeader: PropTypes.bool,
  simple: PropTypes.bool,
  noActionColumn: PropTypes.bool,
  saveAdd: PropTypes.func.isRequired,
  goReadOnly: PropTypes.func.isRequired,
  goAdd: PropTypes.func.isRequired,
  className: PropTypes.string
}

AddressesDisplay.defaultProps = {
  noHeader: false,
  noActionColumn: false,
  simple: false,
  saveDisabled: false,
  addMode: false,
  editMode: false
}



// WEBPACK FOOTER //
// ./src/components/addresses-display/index.js